import React, {Component} from "react";
import config from 'react-global-configuration';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
class DateRangeFilter extends Component {
    state = {
        todSend: this.props.end_date,
        yestSend: this.props.start_date,
        datefrom: this.props.start_date,
        dateTo: this.props.end_date,
        datefromShow: this.props.display_start_date,
        dateToShow: this.props.display_end_date,
    };
    componentDidMount(){

    }
    restDateFilter(start_date, end_date, display_start_date,display_end_date, start_date_val, end_date_val) {
        this.setState({
            todSend: end_date_val,
            yestSend: start_date_val,
            datefrom: start_date,
            dateTo: end_date,
            datefromShow: display_start_date,
            dateToShow: display_end_date,
        })
    }

    handleEvent(event, picker, e){
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),
        });
        if(event.type=='apply') {
            this.props.onSelectDate(moment(picker.endDate).format('YYYY-MM-DD'), moment(picker.startDate).format('YYYY-MM-DD'), moment(picker.startDate).format('D MMM YYYY'),moment(picker.endDate).format('D MMM YYYY'));
        }
    }
    render() {
        let maxDate;
        let minDate;

        if (this.props.is_history === true) {
            maxDate = moment().subtract(1, 'days');   // no format()
            minDate = moment("02/01/2020", "MM/DD/YYYY");
        } else {
            maxDate = moment().add(2, 'days');       // no format()
            minDate = moment();
        }
    console.log("maxDate")
    console.log(maxDate)
    console.log(this.props.start_date_limit)
        return (
            <DateRangePicker startDate={this.props.start_date} endDate={this.props.end_date}
                 onEvent={this.handleEvent.bind(this)}
                 maxDate={maxDate}
                 minDate={minDate}
            >
                <i className="fa fa-calendar" aria-hidden="true"></i>
                <input type="text" name="dateRange" className="form-control dateRangeInput"
                       value={this.props.display_start_date + ' - ' + this.props.display_end_date}/>
            </DateRangePicker>
        );

    }
}
export default DateRangeFilter;